import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import BillPrint from '../sale/Bill';
import ReactDOM from 'react-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip, Button, CircularProgress
} from '@mui/material';

const SaleEdit = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate, roleName } = useAuth();
    const [selectedGWPorPWP, setSelectedGWPorPWP] = useState(false);

    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);

    const [selectedDiscType, setSelectedDiscType] = useState("");
    const [dropdownDiscTypeOptions, setDropdownDiscTypeOptions] = useState([]);

    const [selectedCardType, setSelectedCardType] = useState("");
    const [dropdownCardTypeOptions, setDropdownCardTypeOptions] = useState([]);

    const [showCardFields, setShowCardFields] = useState(false);
    const [showupiFields, setShowupiFields] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        fetchDropdownSalesManOptions();
        fetchDropdownCardTypeOptions();
        fetchDropdownDiscTypeOptions();
    }, []);


    const fetchDropdownSalesManOptions = () => {
        fetchData('SaleApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownSalesManOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Sales Man dropdown options:', error);
            });
    };

    const fetchDropdownDiscTypeOptions = () => {
        fetchData('SaleApi', `/DiscType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownDiscTypeOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Disc Type dropdown options:', error);
            });
    };


    const fetchDropdownCardTypeOptions = () => {
        fetchData('SaleApi', `/CardType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownCardTypeOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Card Type dropdown options:', error);
            });
    };

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    const [formData, setFormData] = useState([]);
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    useEffect(() => {
        fetchData('SaleApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setInvoicedeatils(response.response_data.SaleDetails);
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));

                    setSelectedSalesMan(response.response_data.Sale.SalesManId);
                    setSelectedCardType(response.response_data.Sale.CardType);
                    setSelectedDiscType(response.response_data.Sale.DiscTypeId);
                    setSelectedGWPorPWP(response.response_data.Sale.GWPorPWPIncluded);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        if (name === 'GVAmount') {
            const gvamt = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                GVAmount: gvamt.toFixed(2),
                ModifiedBy: userId,
                SalesManId: selectedSalesMan,
                CardType: selectedCardType
            }));

            const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;

            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvamt, CardAmount, UPIAmount);
        }
        else if (name === 'GSTNumber') {
            const gstno = value;
            setFormData((prevData) => ({
                ...prevData,
                GSTNumber: gstno,
                ModifiedBy: userId,
                SalesManId: selectedSalesMan,
                CardType: selectedCardType
            }));

            const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;

            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2);
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!gstno) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = gstno.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);

        }
        else if (name === 'CardAmount') {

            const cardAmount = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                CardAmount: cardAmount.toFixed(2),
                ModifiedBy: userId,
                SalesManId: selectedSalesMan,
                CardType: selectedCardType
            }));

            const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;

            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2);
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, cardAmount, UPIAmount);

        }
        else if (name === 'UPIAmount') {

            const upiAmount = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                UPIAmount: upiAmount.toFixed(2),
                ModifiedBy: userId,
                SalesManId: selectedSalesMan,
                CardType: selectedCardType
            }));
            const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;

            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2);
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, upiAmount);

        }
        else if (name === 'AdditionalDiscountPercentage') {

            const AdditionalDisc = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                AdditionalDiscountPercentage: AdditionalDisc.toFixed(2),
                ModifiedBy: userId,
            }));


            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2);
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2);
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);
        }
        else {

            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value,
                SalesManId: selectedSalesMan,
                CardType: selectedCardType
            }));

        }

    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.CustomerName) {
            setErrorMessage('Customer Name is required !');
            setIsLoading(false);
            return;
        }

        if (!formData.ContactNumber) {
            setErrorMessage('Contact Number is required !');
            setIsLoading(false);
            return;
        }


        // Cash amount validation
        if (formData.CashAmount < 0) {
            setErrorMessage('Cash Amount less than 0 is not allowed!');
            setIsLoading(false);
            return;
        }

        if (!selectedDiscType && formData.AdditionalDiscountPercentage > 0) {
            setErrorMessage('Disc Type is required !');
            setIsLoading(false);
            return;
        }

        if (selectedDiscType == "1" && !formData.SCMembershipNumber) {
            setErrorMessage('SC Membership Number is required !');
            setIsLoading(false);
            return;
        }

        if (selectedDiscType == "2" && !formData.VoucherNumber) {
            setErrorMessage('Voucher Number is required !');
            setIsLoading(false);
            return;
        }

        // Card amount validation
        if (formData.CardAmount > 0) {
            if (!formData.CardNumber) {
                setErrorMessage('Card Number is required when Card Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
            if (!selectedCardType) {
                setErrorMessage('Card Type is required when Card Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
        }

        if (!selectedSalesMan) {
            setErrorMessage('Sales Man is required !');
            setIsLoading(false);
            return;
        }

        // Upi amount validation
        if (formData.UPIAmount > 0) {
            if (!formData.UPINumber) {
                setErrorMessage('UPI Number is required when UPI Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
        }


        if (!invoicedeatils || invoicedeatils.length === 0) {
            setErrorMessage('Item Details are required!');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
            SalesManId: selectedSalesMan,
            CardType: selectedCardType
        }));

        const CreateData = {
            Sale: formData,
            SaleDetails: invoicedeatils
        };

        // Validate form data here if needed

        updateData('SaleApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);


                if (response.response === 'Sale Updated Successfully') {
                    const SaleId = response.kotId;
                    handlePrint(SaleId);
                }
                history.push('/SaleIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const handlePrint = async (SaleId) => {
        try {

            const response = await fetchData('SaleApi', `/SalePrint/${SaleId}/${branchId}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            // iframe.contentWindow.print();
            setTimeout(() => {
                iframe.contentWindow.print();
            }, 1000);

        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...invoicedeatils];
            updatedRecords.splice(index, 1); // Remove the record at the specified index
            setInvoicedeatils(updatedRecords); // Update the state to reflect the removed record

            const Quantity = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);

        }

    };

    //Items
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItems, setSelectedItem] = useState("");

    useEffect(() => {
        fetchItems();
    }, []);

    const fetchItems = async () => {
        try {
            const response = await fetchData('SaleApi', `/Item/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Code + '-' + item.Name
                }));
                setItemsrOptions(options);
                setItemDetails(response.response_data);
            }

            setFormData(prevData => ({
                ...prevData,
                BranchId: branchId,
                CompanyId: companyId,
                CreatedBy: userId,
            }));

        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    // FOR MODEL DATA (Invoice Details)
    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemId: '',
        Quantity: '1',
        Rate: '',
        Amount: '',
        DiscountPercentage: '',
        DiscountAmount: '',
        HSNCode: '',
        GSTRate: '',
        TaxableAmount: '',
        CGSTAmount: '',
        SGSTAmount: '',
        IGSTAmount: '',
        TotalAmount: '',
        balanceStock: 0,
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName: '',
            ItemId: '',
            Quantity: '1',
            Rate: '',
            Amount: '',
            DiscountPercentage: '',
            DiscountAmount: '',
            HSNCode: '',
            GSTRate: '',
            TaxableAmount: '',
            CGSTAmount: '',
            SGSTAmount: '',
            IGSTAmount: '',
            TotalAmount: '',
            balanceStock: 0,
        });
        setSelectedItem();
        setIsModalOpen(false);
    };

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }

        if (modalData.Quantity > modalData.balanceStock) {
            isValid = false;
            errors = "Quantity exceeds available stock.";
        }


        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...invoicedeatils, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            setInvoicedeatils(updatedInvoicedetailsSorted);

            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName: '',
                ItemId: '',
                Quantity: '1',
                Rate: '',
                Amount: '',
                DiscountPercentage: '',
                DiscountAmount: '',
                HSNCode: '',
                GSTRate: '',
                TaxableAmount: '',
                CGSTAmount: '',
                SGSTAmount: '',
                IGSTAmount: '',
                TotalAmount: '',
                balanceStock: 0,
            });

            setSelectedItem(0);
            //closeModal();

            // Update the totals based on the updatedItemData
            const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);


        } else {

            console.log("Validation errors:", errors);
            setErrorMessageModel(errors);
        }

    };


    const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvamt, CardAmount, UPIAmount) => {

        const gvAmount = parseFloat(gvamt) || 0;

        let netamount = parseFloat(TaxableAmount);
        let netAmt = netamount + parseFloat(CGSTAmount) + parseFloat(SGSTAmount) + parseFloat(IGSTAmount);
        let roundOffValue = Math.round(netAmt) - netAmt;
        let totalAmt = parseFloat((netAmt + roundOffValue)).toFixed(2);
        totalAmt = parseFloat(totalAmt - gvAmount).toFixed(2);
        let cashamt = parseFloat(totalAmt - CardAmount - UPIAmount).toFixed(2);

        setFormData((prevData) => ({
            ...prevData,
            TotalQuantity: Quantity,
            TotalAmount: Amount.toFixed(2),
            DiscountAmount: DiscountAmount.toFixed(2),
            TaxableAmount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            GrandTotal: parseFloat(totalAmt).toFixed(2),
            CashAmount: parseFloat(cashamt).toFixed(2),
            GVAmount: gvAmount.toFixed(2),
            CardAmount: CardAmount.toFixed(2),
            UPIAmount: UPIAmount.toFixed(2),
            CashDiscount: 0,
            ModifiedBy: userId,
        }));
    };

    const [itemdetails, setItemDetails] = useState([]);
    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        setModalData({
            ...modalData,
            ItemName: selectedOption ? selectedOption.label : '',
            ItemId: selectedOption ? selectedOption.value : '',
        });

        // Use Array.prototype.find() to find the rate
        const selectedItemId = selectedOption ? selectedOption.value : '';
        const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;

        const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {

            let quantity = parseFloat(modalData.Quantity) || 0;;
            let rate = parseFloat(selectedItemDetail.MRP.toFixed(2)) || 0;
            let gstrate = parseFloat(selectedItemDetail.GSTRate.toFixed(2)) || 0;
            let discountPercentage = parseFloat(selectedItemDetail.DiscountPercentage.toFixed(2)) || 0;

            let amount = (quantity * rate).toFixed(2);
            let discamt = ((rate * discountPercentage) / 100).toFixed(2)
            let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
            let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
            let grate = (rate - totdiscount).toFixed(2);
            let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
            const taxableamount = (quantity * salerate).toFixed(2);
            const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

            let cgst = 0;
            let sgst = 0;
            let igst = 0;

            if (!formData.GSTNumber) {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            } else {
                const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                if (gstNumberPrefix !== branchstate) {
                    igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                } else {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                }
            }

            const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

            setModalData({
                ...modalData,
                Rate: selectedItemDetail.MRP.toFixed(2), // Assuming Rate is a number
                GSTRate: selectedItemDetail.GSTRate.toFixed(2),
                HSNCode: selectedItemDetail.HSNCode,
                DiscountPercentage: selectedItemDetail.DiscountPercentage.toFixed(2),
                AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: amount,
                DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                TaxableAmount: parseFloat(taxableamount).toFixed(2),
                CGSTAmount: parseFloat(cgst).toFixed(2),
                SGSTAmount: parseFloat(sgst).toFixed(2),
                IGSTAmount: parseFloat(igst).toFixed(2),
                TotalAmount: parseFloat(totalAmount).toFixed(2),
                balanceStock: selectedItemDetail.balanceStock,
            });

        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                Rate: '0.00',
                GSTRate: '0.00',
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                GSTRate: '0',
                HSNCode: '',
                DiscountPercentage: '',
                AdditionalDiscountPercentage: 0,
            });
        }
    };

    const [isValid, setIsValid] = useState(true);
    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        setModalData({
            ...modalData,
            [name]: value,
        });

        const intValue = parseInt(value, 10);

        if (intValue > modalData.balanceStock) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }
        const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;
        let quantity = parseFloat(value) || 0;
        let rate = parseFloat(modalData.Rate) || 0;
        let gstrate = parseFloat(modalData.GSTRate) || 0;
        let discountPercentage = parseFloat(modalData.DiscountPercentage) || 0;

        let amount = (quantity * rate).toFixed(2);
        let discamt = ((rate * discountPercentage) / 100).toFixed(2)
        let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
        let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
        let grate = (rate - totdiscount).toFixed(2);
        let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
        const taxableamount = (quantity * salerate).toFixed(2);
        const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

        let cgst = 0;
        let sgst = 0;
        let igst = 0;

        if (!formData.GSTNumber) {
            cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
        } else {
            const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

            if (gstNumberPrefix !== branchstate) {
                igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
            } else {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            }
        }

        const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

        setModalData({
            ...modalData,
            Quantity: quantity,
            Amount: amount,
            DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
            AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
            AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
            TaxableAmount: parseFloat(taxableamount).toFixed(2),
            CGSTAmount: parseFloat(cgst).toFixed(2),
            SGSTAmount: parseFloat(sgst).toFixed(2),
            IGSTAmount: parseFloat(igst).toFixed(2),
            TotalAmount: parseFloat(totalAmount).toFixed(2),
        });
    };


    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };


    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    const handleEdit = (index, field, value) => {
        setInvoicedeatils((prev = []) => {
            // ===== UPDATE ITEM VALUE =====
            const updatedItems = prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            );

            const gvamt = parseFloat(formData?.GVAmount) || 0;

            // ===== RECALCULATE EACH ITEM =====
            const updatedItemData = updatedItems.map((item) => {
                const rate = parseFloat(item?.Rate) || 0;
                const gstrate = parseFloat(item?.GSTRate) || 0;
                const discountPct = parseFloat(item?.DiscountPercentage) || 0;
                const additionalPct = parseFloat(item?.AdditionalDiscountPercentage) || 0;
                const quantity = parseFloat(item?.Quantity) || 0;

                // Base amount
                const amount = quantity * rate;

                // Discounts (per unit)
                const discAmtPerUnit = (rate * discountPct) / 100;
                const addlDiscAmtPerUnit = (rate * additionalPct) / 100;
                const totalDiscPerUnit = discAmtPerUnit + addlDiscAmtPerUnit;

                // Net & sale rate
                const netRate = rate - totalDiscPerUnit;
                const saleRate = netRate / (1 + gstrate / 100);

                // Taxable & GST
                const taxableAmount = quantity * saleRate;
                let cgst = 0, sgst = 0, igst = 0;

                const gstNumber = formData?.GSTNumber?.toString() || "";
                if (!gstNumber) {
                    // No GST number → CGST + SGST
                    cgst = (taxableAmount * (gstrate / 2)) / 100;
                    sgst = (taxableAmount * (gstrate / 2)) / 100;
                } else {
                    const gstPrefix = gstNumber.substring(0, 2);
                    if (gstPrefix !== branchstate) {
                        igst = (taxableAmount * gstrate) / 100; // Inter-state
                    } else {
                        cgst = (taxableAmount * (gstrate / 2)) / 100;
                        sgst = (taxableAmount * (gstrate / 2)) / 100;
                    }
                }

                const totalAmount = Math.round(taxableAmount + cgst + sgst + igst);

                return {
                    ...item,
                    Amount: amount.toFixed(2),
                    DiscountAmount: (discAmtPerUnit * quantity).toFixed(2),
                    AdditionalDiscountAmount: (addlDiscAmtPerUnit * quantity).toFixed(2),
                    AdditionalDiscountPercentage: additionalPct.toFixed(2),
                    TaxableAmount: taxableAmount.toFixed(2),
                    CGSTAmount: cgst.toFixed(2),
                    SGSTAmount: sgst.toFixed(2),
                    IGSTAmount: igst.toFixed(2),
                    TotalAmount: totalAmount.toFixed(2),
                };
            });

            // ===== GRAND TOTALS =====
            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseFloat(item?.Quantity) || 0;
                    acc.Amount += parseFloat(item?.Amount) || 0;
                    acc.DiscountAmount += parseFloat(item?.DiscountAmount) || 0;
                    acc.AddiDiscountAmount += parseFloat(item?.AdditionalDiscountAmount) || 0;
                    acc.TaxableAmount += parseFloat(item?.TaxableAmount) || 0;
                    acc.CGSTAmount += parseFloat(item?.CGSTAmount) || 0;
                    acc.SGSTAmount += parseFloat(item?.SGSTAmount) || 0;
                    acc.IGSTAmount += parseFloat(item?.IGSTAmount) || 0;
                    acc.TotalAmount += parseFloat(item?.TotalAmount) || 0;
                    return acc;
                },
                {
                    Quantity: 0,
                    Amount: 0,
                    DiscountAmount: 0,
                    AddiDiscountAmount: 0,
                    TaxableAmount: 0,
                    CGSTAmount: 0,
                    SGSTAmount: 0,
                    IGSTAmount: 0,
                    TotalAmount: 0,
                }
            );

            // ===== ADD PAYMENT DATA =====
            const CardAmount = parseFloat(formData?.CardAmount) || 0;
            const UPIAmount = parseFloat(formData?.UPIAmount) || 0;
            const totalDiscount = totals.DiscountAmount + totals.AddiDiscountAmount;

            // ===== FINAL CALL =====
            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totalDiscount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                gvamt,
                CardAmount,
                UPIAmount
            );

            // ✅ Return updated items as new state
            return updatedItemData;
        });
    };


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '100%' }}>

                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.2em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                    `}
                </style>

                <div className="w-full mb-2 flex">
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> Sale - Edit</h6>

                    {/* {roleName == "SuperAdmin" && (
                        <Button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={toggleModal}>
                            <AddIcon style={{ color: 'darkmagenta', fontWeight: 'bolder' }} /><span style={{ color: 'darkmagenta', fontWeight: 'bolder' }}> Add Item</span>
                        </Button>
                    )} */}

                    <Button
                        style={{ marginLeft: '8px', color: 'darkgreen' }}
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} /> {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>SAVE</b>}

                    </Button>

                    <Button

                        component={Link}
                        to="/SaleIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <CloseIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> CANCEL
                    </Button>

                </div>
                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full mb-4 flex" style={{ marginTop: '-1.50%' }}>
                    <div className="container mx-auto mt-2 p-4 max-w-screen-md bg-tabcolor rounded-lg shadow-lg p-6" style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '550px', overflowY: 'auto', maxWidth: '100%' }}>

                        <div className="w-full mb-2 flex" style={{ marginTop: '-1.25%' }}>

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Customer Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.CustomerName}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="CUSTOMER NAME"
                                        name='CustomerName'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Customer Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.CustomerName}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="CUSTOMER NAME"
                                        name='CustomerName'
                                    />
                                </div>

                            )}

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formatDateForInput(formData.BillDate)}
                                        onChange={handleChange}
                                        type="date"
                                        name='BillDate'
                                        disabled
                                    />
                                </div>

                            ) : (

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formatDateForInput(formData.BillDate)}
                                        onChange={handleChange}
                                        type="date"
                                        name='BillDate'
                                    />
                                </div>
                            )}

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Bill Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.BillNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="BILL NUMBER"
                                        name='BillNumber'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Bill Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.BillNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="BILL NUMBER"
                                        name='BillNumber'
                                        readOnly
                                    />
                                </div>
                            )}

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total Qty
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.TotalQuantity}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="TOTAL QUANTITY"
                                    name='TotalQuantity'
                                    readOnly
                                />
                            </div>

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        ADDT'L. DISC Type
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className={`custom-select ${selectedDiscType ? 'fade-in' : 'fade-in'}`}
                                        value={selectedDiscType}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSelectedDiscType(selectedValue);
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                DiscTypeId: selectedValue,
                                            }));
                                        }}
                                        disabled
                                    >
                                        <option value="">Disc Type</option>
                                        {dropdownDiscTypeOptions.map((category) => (
                                            <option key={category.Id} value={category.Id}>
                                                {category.Name}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        ADDT'L. DISC Type
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className={`custom-select ${selectedDiscType ? 'fade-in' : 'fade-in'}`}
                                        value={selectedDiscType}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSelectedDiscType(selectedValue);
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                DiscTypeId: selectedValue,
                                            }));
                                        }}
                                    >
                                        <option value="">Disc Type</option>
                                        {dropdownDiscTypeOptions.map((category) => (
                                            <option key={category.Id} value={category.Id}>
                                                {category.Name}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            )}

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        ADDT'L. Disc %
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.AdditionalDiscountPercentage}
                                        onChange={handleChange}
                                        type="number"
                                        placeholder="Disc %"
                                        style={{ textAlign: 'right' }}
                                        name='AdditionalDiscountPercentage'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        ADDT'L. Disc %
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.AdditionalDiscountPercentage}
                                        onChange={handleChange}
                                        type="number"
                                        placeholder="Disc %"
                                        style={{ textAlign: 'right' }}
                                        name='AdditionalDiscountPercentage'
                                    />
                                </div>
                            )}

                        </div>

                        <div className="w-full mb-4 flex" style={{ marginTop: '-0.50%' }}>
                            {roleName !== "SuperAdmin" ? (
                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Address
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.CustomerAddress}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Address"
                                        name='CustomerAddress'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Address
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.CustomerAddress}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Address"
                                        name='CustomerAddress'
                                    />
                                </div>
                            )}


                            {roleName !== "SuperAdmin" ? (
                                <div className="w-2/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        GST Number
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.GSTNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="GST Number"
                                        name='GSTNumber'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-2/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        GST Number
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.GSTNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="GST Number"
                                        name='GSTNumber'
                                    />
                                </div>
                            )}

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Phone No
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.ContactNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="PHONE NUMBER"
                                        name='ContactNumber'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Phone No
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.ContactNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="PHONE NUMBER"
                                        name='ContactNumber'
                                    />
                                </div>

                            )}


                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Sales Man
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className={`custom-select ${selectedSalesMan ? 'fade-in' : 'fade-in'}`}
                                        value={selectedSalesMan}
                                        // onChange={(e) => setSelectedSalesMan(e.target.value)}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSelectedSalesMan(selectedValue);
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                SalesManId: selectedValue,
                                            }));
                                        }}
                                        disabled
                                    >
                                        <option value="">Select Sales Man</option>
                                        {dropdownSalesManOptions.map((category) => (
                                            <option key={category.Id} value={category.Id}>
                                                {category.Name}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Sales Man
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className={`custom-select ${selectedSalesMan ? 'fade-in' : 'fade-in'}`}
                                        value={selectedSalesMan}
                                        // onChange={(e) => setSelectedSalesMan(e.target.value)}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSelectedSalesMan(selectedValue);
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                SalesManId: selectedValue,
                                            }));
                                        }}
                                    >
                                        <option value="">Select Sales Man</option>
                                        {dropdownSalesManOptions.map((category) => (
                                            <option key={category.Id} value={category.Id}>
                                                {category.Name}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            )}
                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="yes-no-select">
                                        GWP/PWP
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        id="yes-no-select"
                                        className={`custom-select ${selectedGWPorPWP ? 'fade-in' : 'fade-in'}`}
                                        value={selectedGWPorPWP}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value === "true"; // Convert string "true"/"false" to boolean
                                            setSelectedGWPorPWP(selectedValue); // Update state with the selected value
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                GWPorPWPIncluded: selectedValue, // Update form data with the selected value
                                            }));
                                        }}
                                        disabled

                                    >
                                        <option value={true}>YES</option>
                                        <option value={false}>NO</option>
                                    </select>
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="yes-no-select">
                                        GWP/PWP
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        id="yes-no-select"
                                        className={`custom-select ${selectedGWPorPWP ? 'fade-in' : 'fade-in'}`}
                                        value={selectedGWPorPWP}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value === "true"; // Convert string "true"/"false" to boolean
                                            setSelectedGWPorPWP(selectedValue); // Update state with the selected value
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                GWPorPWPIncluded: selectedValue, // Update form data with the selected value
                                            }));
                                        }}

                                    >
                                        <option value={true}>YES</option>
                                        <option value={false}>NO</option>
                                    </select>
                                </div>
                            )}

                        </div>

                        <div className="w-full flex items-center gap-x-2 p-2" style={{ borderRadius: '10px', marginTop: '-1.70%', height: '90px' }}>
                            <div className="w-full mb-4 flex">
                                <div className="w-2/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Weightage">
                                        Item Name
                                    </label>
                                    <Select
                                        value={selectedItems}
                                        onChange={handleItemSelect}
                                        options={itemsOptions}
                                        placeholder="Items"
                                        isSearchable
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: "35px",   // same as your inputs
                                                height: "35px",
                                                fontSize: "14px",
                                            }),
                                            valueContainer: (base) => ({
                                                ...base,
                                                height: "35px",      // keeps text aligned properly
                                                padding: "0 6px",
                                            }),
                                            indicatorsContainer: (base) => ({
                                                ...base,
                                                height: "35px",      // makes dropdown arrow align
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 1301,
                                                fontSize: "14px",
                                            }),
                                        }}
                                    />

                                </div>
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="MinimumStock">
                                        Quantity
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                        type="number"
                                        name="Quantity"
                                        placeholder="Quantity"
                                        value={modalData.Quantity}
                                        onChange={handleModalInputChange}
                                        max={modalData.balanceStock}
                                        min={1}
                                    />
                                    {!isValid && (
                                        <p className="text-red-500 text-xs italic">
                                            Quantity exceeds available stock.
                                        </p>
                                    )}
                                </div>

                                <div className="w-1/5 flex items-end">
                                    <Button className="bg-blue-500 text-white px-3 py-1 rounded flex items-center gap-1" onClick={saveModalData}>
                                        <AddIcon style={{ color: 'darkmagenta', fontWeight: 'bolder' }} />
                                        <span style={{ color: 'darkmagenta', fontWeight: 'bolder' }}>Add Item</span>
                                    </Button>
                                </div>
                            </div>

                        </div>


                        {/* <div className="w-full mb-2 flex" style={{ marginTop: '-0.90%' }}>
                            <div className="w-full mb-2 flex">
                                <TableContainer component={Paper}>
                                    <table className="table">
                                        <thead>
                                            <tr style={{ backgroundColor: '#A1D6B2' }}>
                                                <th style={{ padding: '2px', backgroundColor: '#A1D6B2', textTransform: 'uppercase', fontSize: '13px' }}>Item Name</th>
                                                <th style={{ padding: '2px', backgroundColor: '#A1D6B2', textTransform: 'uppercase', fontSize: '13px', textAlign: 'center' }}>Quantity</th>
                                                <th style={{ padding: '2px', backgroundColor: '#A1D6B2', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right' }}>MRP</th>
                                                <th style={{ padding: '2px', backgroundColor: '#A1D6B2', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right' }}>Disc %</th>
                                                <th style={{ padding: '2px', backgroundColor: '#A1D6B2', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right' }}>Amount</th>
                                                {roleName == "SuperAdmin" && (
                                                    <th style={{ padding: '2px', backgroundColor: '#A1D6B2', textAlign: 'right', textTransform: 'uppercase', fontSize: '13px' }}>Action</th>
                                                )}


                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoicedeatils.map((invdetail, index) => (
                                                <tr key={index} className={invdetail.ColorCode === '#ffffff' ? 'white-row' : ''} style={{ width: '100%' }}>
                                                    <td style={{ padding: '2px', fontSize: '12px', width: '45%', fontWeight: 'bold' }}>{invdetail.ItemName}</td>
                                                    <td style={{ padding: '2px', fontSize: '12px', width: '10%', fontWeight: 'bold', textAlign: 'center' }}>{invdetail.Quantity}</td>
                                                    <td style={{ padding: '2px', fontSize: '12px', width: '10%', fontWeight: 'bold', textAlign: 'right' }}>{invdetail.Rate}</td>
                                                    <td style={{ padding: '2px', fontSize: '12px', width: '10%', fontWeight: 'bold', textAlign: 'right' }}>{invdetail.discountPercentage}</td>
                                                    <td style={{ padding: '2px', fontSize: '12px', width: '15%', fontWeight: 'bold', textAlign: 'right' }}>{invdetail.TotalAmount}</td>

                                                    {roleName == "SuperAdmin" && (
                                                        <td style={{ padding: '2px', marginTop: '-15px', width: '10%', textAlign: 'right' }}>
                                                            <IconButton style={{ padding: '8px', marginTop: '-10px' }} onClick={() => removeRecord(index)}>
                                                                <DeleteIcon style={{ color: 'red' }} />
                                                            </IconButton>
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </TableContainer>

                            </div>
                        </div> */}

                        <div className="w-full mb-2 flex" style={{ marginTop: '-0.50%' }}>
                            <div
                                className="w-full mb-2 flex"
                                style={{
                                    maxHeight: "450px",
                                    overflowY: "auto",
                                    marginTop: "3px",
                                }}
                            >
                                <TableContainer component={Paper}>
                                    <Table stickyHeader>
                                        <TableHead stickyHeader>
                                            <TableRow>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                    }}
                                                >
                                                    Sl.No
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                    }}>
                                                    Item Name
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                    }}>
                                                    Quantity
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                    }}
                                                >
                                                    MRP
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                    }}
                                                >
                                                    Disc %
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                    }}
                                                >
                                                    Addt'l Disc %
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                    }}
                                                >
                                                    Amount
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                        textAlign: "center",
                                                    }}
                                                >

                                                </TableCell>

                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {invoicedeatils.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={7} align="center" style={{ fontSize: "12px", padding: "10px" }}>
                                                        No containers added yet.
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                invoicedeatils.map((item, index) => (
                                                    <TableRow key={index} hover>
                                                        {/* Sl.No (not editable) */}
                                                        <TableCell
                                                            style={{
                                                                fontSize: "13px",
                                                                padding: "6px",
                                                                textAlign: "center",
                                                                borderRight: "1px solid #D6DAC8",
                                                                width: "50px",
                                                                fontWeight: 'bold'
                                                            }}
                                                        >
                                                            {index + 1}
                                                        </TableCell>

                                                        <TableCell style={{ fontSize: "13px", fontWeight: 'bold', padding: "6px", borderRight: "1px solid #D6DAC8", width: '45%' }}>
                                                            {item.ItemName}
                                                        </TableCell>

                                                        <TableCell style={{ fontSize: "13px", fontWeight: 'bold', padding: "6px", borderRight: "1px solid #D6DAC8", textAlign: 'right', width: '7%' }}>
                                                            <input
                                                                type="number"
                                                                value={item.Quantity}
                                                                onChange={(e) =>
                                                                    handleEdit(index, "Quantity", e.target.value)
                                                                }
                                                                style={{ width: "100%", fontSize: "13px", fontWeight: 'bold', padding: "4px", textAlign: 'right' }}
                                                            />
                                                        </TableCell>

                                                        <TableCell style={{ fontSize: "13px", fontWeight: 'bold', padding: "6px", borderRight: "1px solid #D6DAC8", textAlign: 'right', width: '10%' }}>
                                                            {item.Rate}
                                                        </TableCell>

                                                        <TableCell style={{ fontSize: "13px", fontWeight: 'bold', padding: "6px", borderRight: "1px solid #D6DAC8", textAlign: 'right', width: '10%' }}>
                                                            {item.DiscountPercentage}
                                                        </TableCell>

                                                        <TableCell style={{ fontSize: "13px", fontWeight: 'bold', padding: "6px", borderRight: "1px solid #D6DAC8", width: '10%' }}>
                                                            <input
                                                                type="number"
                                                                onChange={(e) =>
                                                                    handleEdit(index, "AdditionalDiscountPercentage", e.target.value)
                                                                }
                                                                value={item.AdditionalDiscountPercentage}
                                                                style={{ width: "100%", fontSize: "13px", fontWeight: 'bold', padding: "4px", textAlign: 'right' }}
                                                            />
                                                        </TableCell>
                                                        <TableCell style={{ fontSize: "13px", fontWeight: 'bold', padding: "6px", borderRight: "1px solid #D6DAC8", textAlign: 'right', width: '10%' }}>
                                                            {item.TotalAmount}
                                                        </TableCell>
                                                        <TableCell
                                                            style={{
                                                                fontSize: "13px",
                                                                padding: "6px",
                                                                textAlign: "right",
                                                                borderRight: "1px solid #D6DAC8",
                                                                width: "50px",
                                                            }}
                                                        >
                                                            <IconButton style={{ padding: '2px', marginTop: '-10px' }} onClick={() => removeRecord(index)}>
                                                                <DeleteIcon style={{ color: 'red' }} />
                                                            </IconButton>

                                                        </TableCell>


                                                    </TableRow>
                                                ))
                                            )}
                                        </TableBody>

                                    </Table>
                                </TableContainer>
                            </div>
                        </div>

                        <div className="w-full mb-2 flex" style={{ marginTop: '-0.90%' }}>

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Remarks
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.Remarks}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="REMARKS"
                                        name='Remarks'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Remarks
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.Remarks}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Remarks"
                                        name='Remarks'
                                    />
                                </div>
                            )}


                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

                                    value={formData.TotalAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="AMOUNT"
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                    name='TotalAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Discount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

                                    value={formData.DiscountAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="DISCOUNT"
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                    name='DiscountAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Cash Disc
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

                                    value={formData.CashDiscount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="CASH DISCOUNT"
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                    name='CashDiscount'
                                    readOnly
                                />
                            </div>

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        GV Amount
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

                                        value={formData.GVAmount}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="GV AMOUNT"
                                        style={{ textAlign: 'right', fontWeight: 'bold' }}
                                        name='GVAmount'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        GV Amount
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

                                        value={formData.GVAmount}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="GV AMOUNT"
                                        style={{ textAlign: 'right', fontWeight: 'bold' }}
                                        name='GVAmount'
                                    />
                                </div>
                            )}


                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Net Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

                                    value={formData.TaxableAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="NET AMOUNT"
                                    name='TaxableAmount'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                        </div>

                        <div className="w-full mb-2 flex">
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    CGST
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

                                    value={formData.CGSTAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="CGST"
                                    name='CGSTAmount'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    SGST
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

                                    value={formData.SGSTAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="SGST"
                                    name='SGSTAmount'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    IGST
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

                                    value={formData.IGSTAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="IGST"
                                    name='IGSTAmount'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Round Off
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.RoundOff}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="ROUND OFF"
                                    name='RoundOff'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

                                    value={formData.GrandTotal}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="GRAND TOTAL"
                                    name='GrandTotal'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Cash
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8 ${formData.CashAmount < 0 ? 'text-red-500' : ''}`}

                                    value={formData.CashAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="CASH"
                                    name='CashAmount'
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                    readOnly
                                />
                            </div>

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Card
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

                                        value={formData.CardAmount}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="CARD"
                                        name='CardAmount'
                                        style={{ textAlign: 'right', fontWeight: 'bold' }}
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Card
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

                                        value={formData.CardAmount}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="CARD"
                                        name='CardAmount'
                                        style={{ textAlign: 'right', fontWeight: 'bold' }}
                                    />
                                </div>
                            )}


                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        UPI/ RTGS/ OTHER
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

                                        value={formData.UPIAmount}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="UPI"
                                        name='UPIAmount'
                                        style={{ textAlign: 'right', fontWeight: 'bold' }}
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        UPI/ RTGS/ OTHER
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

                                        value={formData.UPIAmount}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="UPI"
                                        name='UPIAmount'
                                        style={{ textAlign: 'right', fontWeight: 'bold' }}
                                    />
                                </div>
                            )}

                        </div>

                        <div className="w-full mb-2 flex">
                            {formData.CardAmount > 0 && (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Card Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className={`custom-select ${selectedCardType ? 'fade-in' : 'fade-in'}`}
                                        value={selectedCardType}
                                        // onChange={(e) => setSelectedCardType(e.target.value)}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSelectedCardType(selectedValue);
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                CardType: selectedValue,
                                            }));
                                        }}
                                        disabled={roleName !== "SuperAdmin"}
                                    >
                                        <option value="">Select CardType</option>
                                        {dropdownCardTypeOptions.map((category) => (
                                            <option key={category.Id} value={category.Id}>
                                                {category.Name}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            )}


                            {formData.CardAmount > 0 && (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Card Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.CardNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="CARD NUMBER"
                                        name='CardNumber'
                                        readOnly={roleName !== "SuperAdmin"}
                                    />
                                </div>
                            )}

                            {formData.UPIAmount > 0 && (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        UPI/ RTGS/ OTHER Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.UPINumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="UPI NUMBER"
                                        name='UPINumber'
                                        readOnly={roleName !== "SuperAdmin"}
                                    />
                                </div>
                            )}

                            {formData.DiscTypeId == 1 && (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        SC MembershipNumber
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.SCMembershipNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="SC Membership Number"
                                        name='SCMembershipNumber'
                                        readOnly={roleName !== "SuperAdmin"}
                                    />
                                </div>
                            )}

                            {formData.DiscTypeId == 2 && (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Voucher Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.VoucherNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Voucher Number"
                                        name='VoucherNumber'
                                        readOnly={roleName !== "SuperAdmin"}
                                    />
                                </div>
                            )}
                        </div>

                        {roleName !== "SuperAdmin" ? (
                            <div className="flex justify-left flex-end mr-4">
                                <label className="flex items-center cursor-pointer" style={{ fontWeight: 'bold', color: 'darkblue' }}>
                                    <input
                                        type="checkbox"
                                        className="mr-2 w-4 h-4 accent-blue-500 border-gray-300 rounded focus:ring focus:ring-blue-300"
                                        checked={formData.IsStockTransfer}
                                        name='IsStockTransfer'
                                        onChange={handleChange}
                                        style={{ transform: 'scale(1.2)' }}  // To scale up the checkbox size
                                        disabled
                                    />
                                    INTER CITY STOCK TRANSFER
                                </label>
                            </div>
                        ) : (
                            <div className="flex justify-left flex-end mr-4">
                                <label className="flex items-center cursor-pointer" style={{ fontWeight: 'bold', color: 'darkblue' }}>
                                    <input
                                        type="checkbox"
                                        className="mr-2 w-4 h-4 accent-blue-500 border-gray-300 rounded focus:ring focus:ring-blue-300"
                                        checked={formData.IsStockTransfer}
                                        name='IsStockTransfer'
                                        onChange={handleChange}
                                        style={{ transform: 'scale(1.2)' }}  // To scale up the checkbox size
                                    />
                                    INTER CITY STOCK TRANSFER
                                </label>
                            </div>
                        )}



                    </div>


                </div>


            </div >
        </Fragment >

    );
};

export default SaleEdit;